import Vue from 'vue'
import mutationTypes from '../mutation-type'
import _ from 'lodash'
export default {
  state: {
    // 数据加载状态
    loadState: false
  },
  actions: {

  },
  mutations: {
    // 组卷 新增选中的试题
    [mutationTypes.SET_LOAD] (state, payload) {
      state.loadState = payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js